import { Dashboard } from '../generated/backend-enums.js';
export { Dashboard };
export const DashboardTitleMap = {
    // Atendimento
    [Dashboard.EXECUTIVO_ATENDIMENTO]: 'Executivo',
    [Dashboard.CREDITOS_ATENDIMENTO]: 'Créditos Atendimento',
    [Dashboard.PLANILHAS_ATENDIMENTO]: 'Planilhas Atendimento',
    [Dashboard.SNAPSHOTS_ATENDIMENTO]: 'Snapshots Atendimento',
    // Pré Produção
    [Dashboard.JOBS_PRE_PRODUCAO]: 'Jobs Pré-Produção',
    [Dashboard.PLANILHAS_PRE_PRODUCAO]: 'Planilhas Pré-Produção',
    [Dashboard.EQUIPE_PRE_PRODUCAO]: 'Equipe Pré-Produção',
    // Compras
    [Dashboard.COMPRAS]: 'Compras',
    [Dashboard.EQUIPE_COMPRAS]: 'Equipe Compras',
    [Dashboard.ADIANTAMENTOS_FINANCEIRO]: 'Adiantamentos Financeiro',
    // Antigos (Looker Studio)
    [Dashboard.EXECUTIVO]: 'Executivo (Legado)',
    [Dashboard.DIRETORIA_COMPRAS]: 'Diretoria de Compras',
    [Dashboard.DIRETORIA_ATENDIMENTO]: 'Diretoria de Atendimento',
    [Dashboard.DIRETORIA_PRE_PRODUCAO]: 'Diretoria de Pré-Produção',
};
